export enum ProgressBarVariants {
  Default = 'default',
  // For dark surfaces (e.g. the black setup-checklist card): white-alpha track, info-colored fill + label.
  Inverse = 'inverse',
}
